import cookie from 'js-cookie';

const DEFAULT_LOCALE = 'en';

export const availableLocales = ['fr', 'en', 'it', 'es', 'de'] as const;
export type Locale = (typeof availableLocales)[number];

export const LOCALE_COOKIE_KEY = 'evaneos_ets_locale';

function getCurrentLocaleFromBrowser(): Locale | null {
    const locale = navigator?.language;
    if (!locale) {
        return null;
    }
    const language = locale.split('-')[0];
    return availableLocales.includes(language as Locale)
        ? (language as Locale)
        : null;
}

function getCurrentLocaleFromCookie(): Locale | null {
    const locale = cookie.get(LOCALE_COOKIE_KEY);
    if (!locale) return null;

    return availableLocales.includes(locale as Locale)
        ? (locale as Locale)
        : null;
}

export function getCurrentLocale(): Locale {
    return (
        getCurrentLocaleFromCookie() ||
        getCurrentLocaleFromBrowser() ||
        DEFAULT_LOCALE
    );
}

export const setLocaleCookie = (locale: Locale) => {
    cookie.remove(LOCALE_COOKIE_KEY);
    cookie.set(LOCALE_COOKIE_KEY, locale);
};

type NestedMessages = { [key: string]: string | NestedMessages };

export const flattenMessages = (
    nestedMessages: NestedMessages,
    prefix = ''
): { [key: string]: string } => {
    return Object.keys(nestedMessages).reduce(
        (messages: { [key: string]: string }, key) => {
            const value = nestedMessages[key];
            const prefixedKey = prefix ? `${prefix}.${key}` : key;

            if (typeof value === 'string') {
                messages[prefixedKey] = value;
            } else {
                Object.assign(messages, flattenMessages(value, prefixedKey));
            }

            return messages;
        },
        {} as { [key: string]: string }
    );
};
